import Tabs, {
  TabContent as _TabContent,
  Footer,
  Body,
  LargeText,
  Heading,
  Text,
  TermsBox,
  CourseList,
  CurrentTotal
} from './Tabs';
import Payment from './Payment';
export {
  Footer,
  Body,
  Heading,
  Text,
  TermsBox,
  LargeText,
  CourseList,
  CurrentTotal,
  Payment
};
export type TabContent = _TabContent;
export default Tabs;
